
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/5293eba213fbe763e3b6fb9c801d9617.png" 
                alt="Yıldırım Reklam Logo" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Ankara'da branda baskı ve reklam sektöründe kaliteli hizmet anlayışı ile müşterilerimize en iyi çözümleri sunuyoruz.
            </p>
            <div className="flex space-x-3">
              <a href="https://wa.me/908503073704" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-700 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-whatsapp-fill text-xl"></i>
              </a>
              <a href="tel:+908503073704" className="w-10 h-10 bg-gray-700 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-phone-fill text-xl"></i>
              </a>
              <a href="mailto:yildirimdijital@gmail.com" className="w-10 h-10 bg-gray-700 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-mail-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <a href="#anasayfa" className="text-gray-400 hover:text-red-600 transition-colors cursor-pointer">Ana Sayfa</a>
              </li>
              <li>
                <a href="#hakkimizda" className="text-gray-400 hover:text-red-600 transition-colors cursor-pointer">Hakkımızda</a>
              </li>
              <li>
                <a href="#hizmetler" className="text-gray-400 hover:text-red-600 transition-colors cursor-pointer">Hizmetler</a>
              </li>
              <li>
                <a href="#iletisim" className="text-gray-400 hover:text-red-600 transition-colors cursor-pointer">İletişim</a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">İletişim</h3>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-fill text-red-600 mt-1"></i>
                <span>Kazım Karabekir Cad. No:91 D:28, Altındağ/Ankara</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-fill text-red-600"></i>
                <a href="tel:+903123808099" className="hover:text-red-600 transition-colors cursor-pointer">0312 380 80 99</a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-fill text-red-600"></i>
                <a href="tel:+908503073704" className="hover:text-red-600 transition-colors cursor-pointer">+90 850 307 3704</a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-mail-fill text-red-600"></i>
                <a href="mailto:yildirimdijital@gmail.com" className="hover:text-red-600 transition-colors cursor-pointer">yildirimdijital@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © 2025 Yıldırım Reklam. Tüm hakları saklıdır.
          </p>
          <p className="text-gray-400 text-sm text-center md:text-right">
            Web tasarımı{' '}
            <a 
              href="https://cdco.com.tr" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-red-600 hover:text-red-500 transition-colors font-semibold cursor-pointer"
            >
              CDCO
            </a>
            {' '}tarafından yapılmıştır
          </p>
        </div>
      </div>
    </footer>
  );
}
